//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
 data () {
 return {
   interest:false,
   erweima:'',
   flag:0,
   service_url:''
 }
 },
 components:{
   'v-right': "right"
 },
 mounted(){
   this.$axios.post( `/v8/PC_index/number_two`).then(res => {
        if(res.data.code == 200){
          this.erweima=res.data.data
        }
      }),
     this.$axios.post( `/v4/Index/wxServe`).then(res => {
        this.service_url=res.data.data.service_url;
      })
 },
 methods: {
   show(){
     this.flag=!this.flag
   },
   apply(){
     this.$axios.post(`/v1/member/vip`).then(res=>{
        if(res.data.code==200){
            if(res.data.data.member_info.is_teacher==0){
                this.$tips('您还不是导师~');
            }else{
              this.$router.push("/teacher");
            }
          }
    })
   },
   toTop() {
      var timer = null;
      var obtn = document.getElementById('gotoTop')
      var isTop = true;
      timer = setInterval(function () {
      var osTop = document.documentElement.scrollTop || document.body.scrollTop;
      var ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      isTop = true
      if (osTop == 0) {
        clearInterval(timer)
      }
    }, 30)
  },
   toPage(route){
     this.$router.push(route)
   },
   follows(){
     this.interest=!this.interest
   },
 },
 props:{
    nowHref: {
      type: String,
      default: ""
    },
  },
 created () {
 }
}



// WEBPACK FOOTER //
// ./src/components/common/Right.vue